export default function ChevronLeftIcon() { 
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M16.1553 5.71967C16.4482 6.01256 16.4482 6.48744 16.1553 6.78033L10.4357 12.5L16.1553 18.2197C16.4482 18.5126 16.4482 18.9874 16.1553 19.2803C15.8624 19.5732 15.3876 19.5732 15.0947 19.2803L8.84467 13.0303C8.55178 12.7374 8.55178 12.2626 8.84467 11.9697L15.0947 5.71967C15.3876 5.42678 15.8624 5.42678 16.1553 5.71967Z" fill="black"/>
        </svg>
    );
}